import { getBezierPath, getSimpleBezierPath, getSmoothStepPath, getStraightPath } from '@xyflow/react'

export const getEdgePath = (pathProps, pathType) => {
  switch (pathType) {
    case 'bezier':
      return getBezierPath(pathProps)
    case 'simpleBezier':
      return getSimpleBezierPath(pathProps)
    case 'straight':
      return getStraightPath(pathProps)
    default:
      return getSmoothStepPath(pathProps)
  }
}
